/** This is the same type as mui/table uses **/
export type SortDirection = 'asc' | 'desc'

export enum SortDirectionEnum {
  ascending = 'asc',
  descending = 'desc'
}
